module.exports = new __parcel__URL__("newEditorImage.103374a4.png").toString();